<app-form *ngIf="displayQuestions" [questions]="questions" [object]="object" [extraData]="extraData"></app-form>
